import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1beb778a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tag__warp"
};
const _hoisted_2 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_3 = {
  class: "table__tag"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn__warp"
}, null, -1));

import { getTextWidth } from '@/utils';
const __default__ = {
  name: 'TagType'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    languageOptions: {
      type: Array,
      default: () => []
    },
    currentActive: {
      type: Number,
      default: 0
    },
    buttonsList: {
      type: Array,
      default: () => []
    },
    showAddButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'onTagClick', 'add-drama', 'select-change', 'handleCommand'],

  setup(__props, {
    emit
  }) {
    const props = __props; // label: 语言名称的简写，对应langOptions中的code，这个方法用label从langOptions中找到全程并显示

    const getLangLabel = label => {
      if (!props.languageOptions || !props.languageOptions.length) return label;
      let targetItem = props.languageOptions.filter(item => item.code == label);
      return targetItem.length ? targetItem[0].name : label;
    };

    const stopClick = () => {};

    const handleCommand = (item, type) => {
      emit('handleCommand', {
        type,
        data: item
      });
    }; //  内容超出时显示提示


    const tipDisabled = ref(false);

    const showTextTip = e => {
      const target = e.target;
      const width = getTextWidth(target.innerText, {
        fontSize: '16px',
        fontWeight: 'bold'
      });
      tipDisabled.value = target.offsetWidth < width;
    };

    const onTagClick = (item, index) => {
      emit('onTagClick', item, index);
    };

    const handleAddDrama = () => {
      emit('add-drama');
    };

    return (_ctx, _cache) => {
      const _component_MPopper = _resolveComponent("MPopper");

      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(['tag__item', index === 0 ? 'first__item' : 'other__item', {
            'active': index === __props.currentActive
          }]),
          onClick: $event => onTagClick(item, index),
          key: index
        }, [_createElementVNode("div", {
          style: _normalizeStyle([index == 0 ? 'width: 70%;' : 'width: 50%;', {
            "display": "flex",
            "align-items": "center",
            "justify-content": "space-between"
          }])
        }, [_createVNode(_component_MPopper, {
          disabled: tipDisabled.value,
          placement: "top",
          trigger: "hover",
          content: item.audioLanguage
        }, {
          reference: _withCtx(() => [_createElementVNode("span", {
            onMouseover: showTextTip,
            class: "tag-name"
          }, _toDisplayString(item.audioLanguage), 33)]),
          _: 2
        }, 1032, ["disabled", "content"]), item.icon ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(['iconfont', item.icon])
        }, null, 2)) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
          "show-timeout": 100,
          onClick: _withModifiers(stopClick, ["stop"]),
          onCommand: $event => handleCommand(item, $event)
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
              command: "edit"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('编辑')), 1)]),
              _: 1
            }), _createVNode(_component_el_dropdown_item, {
              command: "delete"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          default: _withCtx(() => [_createElementVNode("i", {
            onClick: _withModifiers(stopClick, ["stop"]),
            class: "iconfont icon-gengduo fs--26 more__setting"
          }, null, 8, _hoisted_5)]),
          _: 2
        }, 1032, ["onClick", "onCommand"])], 4)], 10, _hoisted_4);
      }), 128)), __props.showAddButton ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: handleAddDrama,
        class: "tag__item other__item",
        style: {
          "min-width": "100px",
          "font-size": "20px",
          "margin-left": "-30px"
        }
      }, " + ")) : _createCommentVNode("", true)])]), _hoisted_6]);
    };
  }

});